// extracted by mini-css-extract-plugin
export var growableInput = "_aw-0";
export var tagContainer = "_aw-2";
export var textInput = "_aw-1";